import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class config_general_template extends vnTemplate {

    protected externalLinkWhitelistTooltip: infoButton_template;

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["ww-form", "config-general"];
    }

    protected buildViewModel(): any {
        let self = this
        let viewModel = {

            // relatedBrandLinks: ko.observableArray([]),

            //Follow Us Links Here !

            facebookType: ko.observable("facebook"),
            facebookLink: ko.observable(""),
            enableFacebookLink: ko.observable(false),

            twitterType: ko.observable("twitter"),
            twitterLink: ko.observable(""),
            enableTwitterLink: ko.observable(false),

            tiktokType: ko.observable("tiktok"),
            tiktokLink: ko.observable(""),
            enableTiktokLink: ko.observable(false),

            linkedInType: ko.observable("linkedin"),
            linkedInLink: ko.observable(""),
            enableLinkedInLink: ko.observable(false),

            threadsType: ko.observable("threads"),
            threadsLink: ko.observable(""),
            enableThreadsLink: ko.observable(false),

            blueSkyType: ko.observable("bluesky"),
            blueSkyLink: ko.observable(""),
            enableBlueSkyLink: ko.observable(false),

            twitchType: ko.observable("twitch"),
            twitchLink: ko.observable(""),
            enableTwitchLink: ko.observable(false),

            instagramType: ko.observable("instagram"),
            instagramLink: ko.observable(""),
            enableInstagramLink: ko.observable(false),

            pinterestType: ko.observable("pinterest"),
            pinterestLink: ko.observable(""),
            enablePinterestLink: ko.observable(false),

            spotifyType: ko.observable("spotify"),
            spotifyLink: ko.observable(""),
            enableSpotifyLink: ko.observable(false),

            anchorType: ko.observable("anchor"),
            anchorLink: ko.observable(""),
            enableAnchorLink: ko.observable(false),

            megaphoneType: ko.observable("megaphone"),
            megaphoneLink: ko.observable(""),
            enableMegaphoneLink: ko.observable(false),

            discordType: ko.observable("discord"),
            discordLink: ko.observable(""),
            enableDiscordLink: ko.observable(false),

            telegramType: ko.observable("telegram"),
            telegramLink: ko.observable(""),
            enableTelegramLink: ko.observable(false),

            snapchatType: ko.observable("snapchat"),
            snapchatLink: ko.observable(""),
            enableSnapchatLink: ko.observable(false),

            youtubeType: ko.observable("youtube"),
            youtubeLink: ko.observable(""),
            enableYoutubeLink: ko.observable(false),

            rssFeedType: ko.observable("feed"),
            rssFeedLink: ko.observable(""),
            enableRssFeedkLink: ko.observable(false),

            newsLetterType: ko.observable("newspaper"),
            newsLetterLink: ko.observable(""),
            enableNewsletterLink: ko.observable(false),

            feedlyType: ko.observable("feedly"),
            feedlyLink: ko.observable(""),
            enableFeedlyLink: ko.observable(false),

            pushbulletType: ko.observable("pushbullet"),
            pushbulletLink: ko.observable(""),
            enablePushbulletLink: ko.observable(false),

            googleNewsType: ko.observable("google-news"),
            googleNewsLink: ko.observable(""),
            enableGoogleNewsLink: ko.observable(false),

            googleDiscoverType: ko.observable("google-discover"),
            googleDiscoverLink: ko.observable(""),
            enableGoogleDiscoverLink: ko.observable(false),

            googleSearchType: ko.observable("google-search"),
            googleSearchLink: ko.observable(""),
            enableGoogleSearchLink: ko.observable(false),

            redditType: ko.observable("reddit"),
            redditLink: ko.observable(""),
            enableRedditLink: ko.observable(false),

            flipboardType: ko.observable("flipboard"),
            flipboardLink: ko.observable(""),
            enableFlipboardLink: ko.observable(false),

            amazonType: ko.observable("amazon"),
            amazonLink: ko.observable(""),
            enableAmazonLink: ko.observable(false),

            acastType: ko.observable("acast"),
            acastLink: ko.observable(""),
            enableAcastLink: ko.observable(false),

            //end of follow us links!
            siteName: ko.observable(""),
            alternateSiteName: ko.observable(""),
            title: ko.observable(""),
            description: ko.observable(""),
            rssChannelDescription: ko.observable(""),
            rssAdContent: ko.observable(""),
            foundingDate: ko.observable(""),
            gtmAccount: ko.observable(""),
            fbappAccount: ko.observable(""),
            metaPixelId: ko.observable(""),
            sitega4MeasurementId: ko.observable(""),
            sentinelMeasurementID: ko.observable(""),
            matomoSiteId: ko.observable(""),
            matomoUrl: ko.observable(""),
            brazeWebApiKey: ko.observable(""),
            brazeSdkEndpoint: ko.observable(""),
            campaignerAccountId: ko.observable(""),
            disqusCommentCountOnBrowseClip: ko.observable(false),
            echoboxEnable: ko.observable(false),
            disqusForumShortname: ko.observable(""),
            openwebSpotId: ko.observable(""),
            sovrnId: ko.observable(""),
            skimlinksId: ko.observable(""),
            howlId: ko.observable(""),
            pencilBanner: ko.observable({
                isEnable: ko.observable(false),
                linkText: ko.observable(""),
                linkUrl: ko.observable(""),
            }),
            pencilBannerTextLinkCount: ko.observable(0),
            contactAddress: ko.observable(""),
            externalLinkWhitelist: ko.observable(""),


            onClickCancelRelatedBrandLinks: function (data, event) {
                self.onClickCancelRelatedBrandLinks()
            },
            // onClickSaveRelatedBrandLinks: function (data, param, event) {
            //     self.onClickSaveRelatedBrandLinks(data, param)
            // },
            onClickCancelFollowUsLinks: function (data, event) {
                self.onClickCancelFollowUsLinks()
            },
            onClickSaveFollowUsLinks: function (data, param, event) {
                self.onClickSaveFollowUsLinks(data, param)
            },
            onClickCancelSiteSettings: function (data, event) {
                self.onClickCancelSiteSettings()
            },
            onClickSaveSiteSettings: function (data, param, event) {
                self.onClickSaveSiteSettings()
            },
            onClickSavePencilBanner: function (data, param, event) {
                self.onClickSavePencilBanner(data, param)
            },
            onClickCancelPencilBanner: function () {
                self.onClickCancelPencilBanner()
            },

        };

        viewModel.pencilBanner().linkText.subscribe(function (textValue) {
            self.updatePencilBannerCount(textValue)
        }, viewModel);

        return viewModel
    }

    protected getTemplateHtml(): string {
        return /* html */ `
        <div class="w-form config-link">
<!--            <div class="form-header">-->
<!--                <h3 class="form-title">Related brand links</h3>-->
<!--            </div>-->
<!--            <div class="form-body" data-bind="foreach: relatedBrandLinks">-->
<!--                <div class="w-form-body">-->
<!--                    <input type="hidden" data-bind="value: idBrand">-->
<!--                    <strong class="form-sub-title dark" data-bind="text: $data.brandName, css: brandIcon"></strong>-->
<!--                    <div class="form-group absolute">-->
<!--                        <input type="checkbox" data-bind="checked: enabled, attr: {id: 'related_brand_enabled_' + $index()}">-->
<!--                        <label data-bind="attr: {for: 'related_brand_enabled_' + $index()}" class="form-label icon i-check">Enabled</label> -->
<!--                    </div>-->
<!--                    <div class="form-group row">-->
<!--                        <label data-bind="attr: {for: 'text_content_'+ $index()}" class="form-label">Text</label> -->
<!--                        <input class="input-text" type="text" data-bind="value: text, attr: {id: 'text_content_'+ $index()}" >-->
<!--                    </div>-->
<!--                   -->
<!--                </div>         -->
<!--            </div>-->
<!--            <div class="form-footer">-->
<!--                <button data-bind="event: {click: onClickCancelRelatedBrandLinks}" class="btn " type="button">Cancel</button>-->
<!--                <button data-bind="event: {click: onClickSaveRelatedBrandLinks.bind(relatedBrandLinks, 'related_brands')}" class="btn highlight" type="button">Save</button>-->
<!--            </div>-->

                <div class="form-header">
                    <h3 class="form-title">Follow us links</h3>
                </div>
                <div class="form-body">

                    <!--youtube-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-youtube icon form-label" data-bind="text: youtubeType" for="youtube">Youtube</label>
                            <div class="form-check-inline">
                                <input id="youtube_enable" type="checkbox" data-bind="checked: enableYoutubeLink">
                                <label for="youtube_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="youtube" data-bind="value: youtubeLink">
                        </div>
                    </div>
                    <!--youtube-->

                    <!--facebook-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-facebook" data-bind="text: facebookType" for="facebook"></label>
                            <div class="form-check-inline">
                                <input id="facebook_enable" type="checkbox" data-bind="checked: enableFacebookLink">
                                <label for="facebook_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="facebook" data-bind="value :facebookLink">
                        </div>
                    </div>
                     <!--facebook-->

                     <!--instagram-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-insta" data-bind="text: instagramType" for="instagram"></label>
                            <div class="form-check-inline">
                                <input id="instagram_enable" type="checkbox" data-bind="checked: enableInstagramLink">
                                <label for="instagram_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="instagram" data-bind="value: instagramLink">
                        </div>
                    </div>
                    <!--instagram-->

                    <!--twitter-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-twitter" data-bind="text: twitterType" for="twitter"></label>
                            <div class="form-check-inline">
                                <input id="twitter_enable" type="checkbox" data-bind="checked: enableTwitterLink" >
                                <label for="twitter_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="twitter" data-bind="value: twitterLink">
                        </div>
                    </div>
                    <!--twitter-->

                    <!--reddit-->
                     <div class="w-form-group">
                        <div class="form-group row">
                             <label class="icon i-reddit form-label" data-bind="text: redditType" for="reddit"></label>
                             <div class="form-check-inline">
                                <input id="reddit_enable" type="checkbox" data-bind="checked: enableRedditLink" >
                                <label for="reddit_enable" class="form-label icon i-check">Enabled</label>
                             </div>
                        </div>
                        <div class="form-group row">
                             <label class="form-label short">URL</label>
                             <input class="input-text" type="text" id="reddit" data-bind="value: redditLink">
                         </div>
                    </div>
                    <!--reddit-->

                    <!--tiktok-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="icon i-tiktok form-label" data-bind="text: tiktokType" for="tiktok"></label>
                             <div class="form-check-inline">
                                <input id="tiktok_enable" type="checkbox" data-bind="checked: enableTiktokLink" >
                                <label for="tiktok_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="tiktok" data-bind="value: tiktokLink">
                        </div>
                    </div>
                    <!--tiktok-->

                    <!--linkedIn-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="icon i-linkedin form-label" data-bind="text: linkedInType" for="linkedIn"></label>
                             <div class="form-check-inline">
                                <input id="linkedIn_enable" type="checkbox" data-bind="checked: enableLinkedInLink" >
                                <label for="linkedIn_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="linkedIn" data-bind="value: linkedInLink">
                        </div>
                    </div>
                    <!--linkedIn-->

                    <!--threads-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="icon i-threads form-label" data-bind="text: threadsType" for="threads"></label>
                             <div class="form-check-inline">
                                <input id="threads_enable" type="checkbox" data-bind="checked: enableThreadsLink" >
                                <label for="threads_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="threads" data-bind="value: threadsLink">
                        </div>
                    </div>
                    <!--threads-->

                    <!--bluesky-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="icon i-bluesky form-label" data-bind="text: blueSkyType" for="bluesky"></label>
                             <div class="form-check-inline">
                                <input id="bluesky_enable" type="checkbox" data-bind="checked: enableBlueSkyLink" >
                                <label for="bluesky_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="bluesky" data-bind="value: blueSkyLink">
                        </div>
                    </div>
                    <!--bluesky-->

                    <!--twitch-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-twitch" data-bind="text: twitchType" for="twitch"></label>
                            <div class="form-check-inline">
                                <input id="twitch_enable" type="checkbox" data-bind="checked: enableTwitchLink" >
                                <label for="twitch_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="tiktok" data-bind="value: twitchLink">
                        </div>
                    </div>
                    <!--twitch-->


                    <!--pinterest-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-pinterest" data-bind="text: pinterestType" for="pinterest"></label>
                             <div class="form-check-inline">
                                <input id="pinterest_enable" type="checkbox" data-bind="checked: enablePinterestLink" >
                                <label for="pinterest_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="pinterest" data-bind="value: pinterestLink">
                        </div>
                    </div>
                    <!--pinterest-->

                    <!--spotify-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-spotify" data-bind="text: spotifyType" for="spotify"></label>
                             <div class="form-check-inline">
                                <input id="spotify_enable" type="checkbox" data-bind="checked: enableSpotifyLink" >
                                <label for="spotify_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="spotify" data-bind="value: spotifyLink">
                        </div>
                    </div>
                    <!--spotify-->

                    <!--anchor-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-anchor" data-bind="text: anchorType" for="anchor"></label>
                             <div class="form-check-inline">
                                <input id="anchor_enable" type="checkbox" data-bind="checked: enableAnchorLink" >
                                <label for="anchor_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="anchor" data-bind="value: anchorLink">
                        </div>
                    </div>
                    <!--anchor-->

                    <!--megaphone-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-megaphone" data-bind="text: megaphoneType" for="megaphone"></label>
                             <div class="form-check-inline">
                                <input id="megaphone_enable" type="checkbox" data-bind="checked: enableMegaphoneLink" >
                                <label for="megaphone_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="megaphone" data-bind="value: megaphoneLink">
                        </div>
                    </div>
                    <!--megaphone-->

                    <!--acast-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-acast" data-bind="text: acastType" for="acast"></label>
                             <div class="form-check-inline">
                                <input id="acast_enable" type="checkbox" data-bind="checked: enableAcastLink" >
                                <label for="acast_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="acast" data-bind="value: acastLink">
                        </div>
                    </div>
                    <!--acast-->

                    <!--discord-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-discord" data-bind="text: discordType" for="discord"></label>
                             <div class="form-check-inline">
                                <input id="discord_enable" type="checkbox" data-bind="checked: enableDiscordLink" >
                                <label for="discord_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="discord" data-bind="value: discordLink">
                        </div>
                    </div>
                    <!--discord-->

                    <!--telegram-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-telegram" data-bind="text: telegramType" for="telegram"></label>
                             <div class="form-check-inline">
                                <input id="telegram_enable" type="checkbox" data-bind="checked: enableTelegramLink" >
                                <label for="telegram_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="telegram" data-bind="value: telegramLink">
                        </div>
                    </div>
                    <!--telegram-->

                    <!--snapchat-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-snapchat" data-bind="text: snapchatType" for="snapchat"></label>
                             <div class="form-check-inline">
                                <input id="snapchat_enable" type="checkbox" data-bind="checked: enableSnapchatLink" >
                                <label for="snapchat_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="snapchat" data-bind="value: snapchatLink">
                        </div>
                    </div>
                    <!--snapchat-->

                    <!--Google Search-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-google icon form-label" for="googleSearch">Google Search Preferred Source</label>
                            <div class="form-check-inline">
                                <input id="googleSearch_enable" type="checkbox" data-bind="checked: enableGoogleSearchLink">
                                <label for="googleSearch_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                         </div>
                         <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="googleSearch" data-bind="value: googleSearchLink">
                        </div>
                    </div>
                    <!--google search-->

                    <!--Google Discover-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-google-discovery icon form-label" for="googleDiscover">Google Discover</label>
                            <div class="form-check-inline">
                                <input id="googleDiscover_enable" type="checkbox" data-bind="checked: enableGoogleDiscoverLink">
                                <label for="googleDiscover_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                         </div>
                         <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="googleDiscover" data-bind="value: googleDiscoverLink">
                        </div>
                    </div>
                    <!--google discover-->

                    <!--Google News-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-googlenews icon form-label" for="googleNews">Google News</label>
                            <div class="form-check-inline">
                                <input id="googleNews_enable" type="checkbox" data-bind="checked: enableGoogleNewsLink">
                                <label for="googleNews_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                         </div>
                         <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="googleNews" data-bind="value: googleNewsLink">
                        </div>
                    </div>
                    <!--google news-->

                    <!--feedly-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-feedly" data-bind="text: feedlyType" for="feedly"></label>
                            <div class="form-check-inline">
                                <input id="feedly_enable" type="checkbox" data-bind="checked: enableFeedlyLink">
                                <label for="feedly_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="feedly" data-bind="value: feedlyLink">
                        </div>
                    </div>
                    <!--feedly-->

                    <!--flipboard-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-flipboard" data-bind="text: flipboardType" for="flipboard"></label>
                            <div class="form-check-inline">
                                <input id="flipboard_enable" type="checkbox" data-bind="checked: enableFlipboardLink">
                                <label for="flipboard_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="flipboard" data-bind="value: flipboardLink">
                        </div>
                    </div>

                    <!--flipboard-->

                    <!--pushbullet-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="form-label icon i-pushbullet" data-bind="text: pushbulletType" for="pushbullet"></label>
                            <div class="form-check-inline">
                                <input id="pushbullet_enable" type="checkbox" data-bind="checked: enablePushbulletLink">
                                <label for="pushbullet_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                       </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="pushbullet" data-bind="value: pushbulletLink">
                        </div>
                    </div>
                    <!--pushbullet-->

                    <!--rss feed-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-rss icon form-label" for="rssfeed">RSS Feed</label>
                            <div class="form-check-inline">
                                <input id="rssfeed_enable" type="checkbox" data-bind="checked: enableRssFeedkLink">
                                <label for="rssfeed_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="rssfeed" data-bind="value: rssFeedLink">
                        </div>
                    </div>
                    <!--rss feed-->

                    <!--newsletter-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-newsletter icon form-label" for="newsletter">Newsletter</label>
                            <div class="form-check-inline">
                                <input id="newsletter_enable" type="checkbox" data-bind="checked: enableNewsletterLink">
                                <label for="newsletter_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="newsletter" data-bind="value: newsLetterLink">
                        </div>
                    </div>
                    <!--newsletter-->

                    <!--Amazon-->
                    <div class="w-form-group">
                        <div class="form-group row">
                            <label class="i-amazon icon form-label" for="amazon">Amazon</label>
                            <div class="form-check-inline">
                                <input id="amazon_enable" type="checkbox" data-bind="checked: enableAmazonLink">
                                <label for="amazon_enable" class="form-label icon i-check">Enabled</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="form-label short">URL</label>
                            <input class="input-text" type="text" id="amazon" data-bind="value: amazonLink">
                        </div>
                    </div>
                    <!--Amazon-->

                </div>

                <div class="form-footer">
                    <button data-bind="event: {click: onClickCancelFollowUsLinks}" class="btn " type="button">Cancel</button>
                    <button data-bind="event: {click: onClickSaveFollowUsLinks.bind( null ,'follow_links')}" class="btn highlight" type="button">Save</button>
                </div>

            </div>

        <!-- Pencil banner -->
        <div class="w-form-side">
<!--            <div class="w-form" style="margin: 2rem 0 0 2rem">-->
<!--                <div class="form-header">-->
<!--                    <h3 class="form-title">Pencil Banner</h3>-->
<!--                </div>-->

<!--                <div class="form-body">-->
<!--                   <div class="w-form-body">-->
<!--                       <div class="form-group row">-->
<!--                            <input type="checkbox" data-bind="checked: pencilBanner().isEnable, attr: {id: 'pencilbanner-checkbox'}">-->
<!--                            <label data-bind="attr: {for: 'pencilbanner-checkbox'}" class="form-label icon i-check">Enable Pencil Banner</label>-->
<!--                       </div>-->

<!--                        <div class="form-group">-->
<!--                            <label for="pb_link_text" class="form-label">Link text</label>-->
<!--                            <textarea class="input-text" data-bind="textInput: pencilBanner().linkText " id="pb_link_text" maxlength="200"></textarea>-->
<!--                            <p><small-->
<!--                                class="form-text"-->
<!--                                data-bind="text : pencilBannerTextLinkCount() + '/200 characters' "-->
<!--                                style="font-size: xx-small; font-weight: lighter"></small>-->
<!--                            </p>-->
<!--                        </div>-->

<!--                        <div class="form-group">-->
<!--                            <label for="pb_link_url" class="form-label">Link url</label>-->
<!--                            <textarea class="input-text" data-bind="textInput: pencilBanner().linkUrl " id="pb_link_url"></textarea>-->
<!--                        </div>-->


<!--                   </div>-->
<!--                </div>-->
<!--                <div class="form-footer">-->
<!--                    <button data-bind="event: {click: onClickCancelPencilBanner}" class="btn " type="button">Cancel</button>-->
<!--                    <button-->
<!--                        data-bind="event: {click: onClickSavePencilBanner.bind(pencilBanner, 'pencil_banner')}"-->
<!--                        class="btn highlight" type="button" >Save</button>-->
<!--                </div>-->
<!--            </div>-->

            <div class="w-form config-settings">
            <div class="form-header">
                <h3 class="form-title">Site Settings</h3>
            </div>
            <div class="form-body">
                <div class="w-form-body">
                    <div class="form-group row top">
                        <label for="siteName" class="form-label">Site Name</label>
                        <input class="input-text" type="text" data-bind="value: siteName" id="siteName" />
                    </div>
                    <div class="form-group row top">
                        <label for="alternateSiteName" class="form-label">Alternate Site Name</label>
                        <input class="input-text" type="text" data-bind="value: alternateSiteName" id="alternateSiteName" />
                    </div>
                    <div class="form-group row top">
                        <label for="siteTitle" class="form-label">Title</label>
                        <textarea class="input-text" type="text" data-bind="value: title" id="siteTitle"></textarea>
                    </div>
                    <div class="form-group row top">
                        <label for="siteDescription" class="form-label">Description</label>
                        <textarea class="input-text" type="text" data-bind="value: description" id="siteDescription" ></textarea>
                    </div>
                    <div class="form-group row">
                        <label for="siteFoundingDate" class="form-label">Founding Date</label>
                        <input class="input-text" type="text" data-bind="value: foundingDate" id="siteFoundingDate">
                    </div>
                    <div class="form-group row">
                        <label for="sitegtmAccount" class="form-label">Google Tag Manager ID</label>
                        <input class="input-text" type="text" data-bind="value: gtmAccount"  id="sitegtmAccount">
                    </div>
                    <div class="form-group row">
                        <label for="sitefbappAccount" class="form-label">FB App ID</label>
                        <input class="input-text" type="text" data-bind="value: fbappAccount" id="sitefbappAccount" >
                    </div>
                    <div class="form-group row">
                        <label for="metaPixelId" class="form-label">Meta Pixel ID</label>
                        <input class="input-text" type="text" data-bind="value: metaPixelId" id="metaPixelId">
                    </div>
                    <div class="form-group row">
                        <label for="sitega4MeasurementId" class="form-label">GA Measurement ID</label>
                        <input class="input-text" type="text" data-bind="value: sitega4MeasurementId" id="sitega4MeasurementId" >
                    </div>
                    <div class="form-group row">
                        <label for="sentinelMeasurementID" class="form-label">Sentinel Measurement ID</label>
                        <input class="input-text" type="text" data-bind="value: sentinelMeasurementID" id="sentinelMeasurementID" >
                    </div>
                    <div class="form-group row">
                        <label for="matomoSiteId" class="form-label">Matomo Site ID</label>
                        <input class="input-text" type="text" data-bind="value: matomoSiteId" id="matomoSiteId" >
                    </div>
                    <div class="form-group row">
                        <label for="matomoUrl" class="form-label">Matomo URL</label>
                        <input class="input-text" type="text" data-bind="value: matomoUrl" id="matomoUrl" placeholder="e.g. https://poly.matomo.cloud/">
                    </div>
                    <div class="form-group row">
                        <label for="brazeWebApiKey" class="form-label">Braze API Key</label>
                        <input class="input-text" type="text" data-bind="value: brazeWebApiKey" id="brazeWebApiKey" placeholder="Web SDK key from Braze App Settings">
                    </div>
                    <div class="form-group row">
                        <label for="brazeSdkEndpoint" class="form-label">Braze SDK Endpoint</label>
                        <input class="input-text" type="text" data-bind="value: brazeSdkEndpoint" id="brazeSdkEndpoint" placeholder="e.g. sdk.iad-07.braze.com">
                    </div>
<!--                    <div class="form-group row">-->
<!--                        <label for="campaignerAccountId" class="form-label">Campaigner Account ID</label>-->
<!--                        <input class="input-text" type="text" data-bind="value: campaignerAccountId" id="campaignerAccountId" >-->
<!--                    </div>-->
<!--                    <div class="form-group row top">-->
<!--                        <label for="rssChannelDescription" class="form-label">SmartNews RSS Channel Description</label>-->
<!--                        <textarea class="input-text" type="text" data-bind="value: rssChannelDescription" id="rssChannelDescription" ></textarea>-->
<!--                    </div>-->
<!--                    <div class="form-group row top">-->
<!--                        <label for="rssAdContent" class="form-label">SmartNews RSS Ad Content</label>-->
<!--                        <textarea class="input-text" type="text" data-bind="value: rssAdContent" id="rssAdContent" ></textarea>-->
<!--                    </div>-->
<!--                    <div class="form-group row">-->
<!--                        <label for="sitega4MeasurementId" class="form-label">DISQUS FORUM SHORTNAME</label>-->
<!--                        <input class="input-text" type="text" data-bind="value: disqusForumShortname" id="disqusForumShortname" >-->
<!--                    </div>-->
<!--                    <div class="form-group row" data-bind="visible: disqusForumShortname()">-->
<!--                        <label for="disqusCommentCountOnBrowseClip" class="form-label">DISQUS COMMENT COUNT ON BROWSECLIP</label>-->
<!--                         <div class="form-check-inline">-->
<!--                                <input id="disqusCommentCountOnBrowseClip" type="checkbox" data-bind="checked: disqusCommentCountOnBrowseClip">-->
<!--                                <label for="disqusCommentCountOnBrowseClip" class="form-label icon i-check">Enabled</label>-->
<!--                            </div>-->
<!--                    </div>-->
<!--                    <div class="form-group row">-->
<!--                        <label for="openwebSpotId" class="form-label">OPENWEB SPOT ID</label>-->
<!--                        <input class="input-text" type="text" data-bind="value: openwebSpotId" id="openwebSpotId" >-->
<!--                    </div>-->
                </div>

                <div class="form-group row" >
                    <label for="echoBoxEnable" class="form-label">Echobox</label>
                    <div class="form-check-inline">
                        <input id="echoBoxEnable" type="checkbox" data-bind="checked: echoboxEnable">
                        <label for="echoBoxEnable" class="form-label icon i-check">Enabled</label>
                    </div>
                </div>
<!--                <div class="form-group row top">-->
<!--                    <label for="contactAddress" class="form-label">Contact-us Address</label>-->
<!--                    <textarea class="input-text" type="text" data-bind="value: contactAddress" id="contactAddress"></textarea>-->
<!--                </div>-->
                <div class="form-group row top">
                    <div style="display: flex;">
                        <label for="externalLinkWhitelist" class="form-label">External Link Whitelist</label>
                        <div class="w-tooltips-adv pos-top">
                            ${ this.externalLinkWhitelistTooltip.getHtmlBuild() }
                        </div>
                    </div>
                    <textarea class="input-text" type="text" data-bind="value: externalLinkWhitelist" id="externalLinkWhitelist"></textarea>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: {click: onClickCancelSiteSettings}" class="btn " type="button">Cancel</button>
                <button data-bind="event: {click: onClickSaveSiteSettings}" class="btn highlight" type="button">Save</button>
            </div>
        </div>

        </div>

         `;
    }

    protected initPartial(): void {

        this.externalLinkWhitelistTooltip = new infoButton_template('externalLinkWhitelistTooltip', this.getTemplateViewModel(), this.caller)
        this.externalLinkWhitelistTooltip.setTitle('Help: External Link Whitelist');

        let toolTipText =  `
            <div style="display: flex;align-items: flex-start">
            <p>Domains included in the External Link Whitelist will be added by the Emaki link tool with an “External Link” target rather than an "External NoFollow Link" target</p>
            </div>`;+

        this.externalLinkWhitelistTooltip.setContent(toolTipText);
    }


    protected getTemplateName(): string {
        return "config_general_template";
    }

    // public setRelatedBrandLinks(obj) {
    //     this.getTemplateViewModel().relatedBrandLinks(obj)
    // }

    public setPencilBanner(pencilBanner) {
        this.getTemplateViewModel().pencilBanner().isEnable(pencilBanner.isEnable);
        this.getTemplateViewModel().pencilBanner().linkText(pencilBanner.linkText);
        this.getTemplateViewModel().pencilBanner().linkUrl(pencilBanner.linkUrl);
    }

    public getPencilBanner() {
        return this.getTemplateViewModel().pencilBanner();
    }

    public clearPencilBanner() {
        this.getTemplateViewModel().pencilBanner().linkText('');
        this.getTemplateViewModel().pencilBanner().linkUrl('');
    }

    public isPencilBannerEnabled(): boolean {
        return this.getTemplateViewModel().pencilBanner().isEnable()
    }

    //start site settings

    public setSiteName(siteName) {
        this.getTemplateViewModel().siteName(siteName);
    }

    public setContactAddress(contactAddress) {
        this.getTemplateViewModel().contactAddress(contactAddress);
    }

    public setExternalLinkWhitelist(externalLinkWhitelist) {
        this.getTemplateViewModel().externalLinkWhitelist(externalLinkWhitelist);
    }

    public setAlternateSiteName(alternateSiteName) {
        this.getTemplateViewModel().alternateSiteName(alternateSiteName);
    }

    public setTitle(obj) {
        this.getTemplateViewModel().title(obj)
    }

    public setDescription(obj) {
        this.getTemplateViewModel().description(obj)
    }

    public setRssChannelDescription(obj) {
        this.getTemplateViewModel().rssChannelDescription(obj)
    }

    public setRssAdContent(obj) {
        this.getTemplateViewModel().rssAdContent(obj)
    }

    public setFoundingDate(obj) {
        this.getTemplateViewModel().foundingDate(obj)
    }


    public setGtmAccount(obj) {
        this.getTemplateViewModel().gtmAccount(obj)
    }

    public setFbAppAccount(obj) {
        this.getTemplateViewModel().fbappAccount(obj)
    }

    public setMetaPixelId(obj) {
        this.getTemplateViewModel().metaPixelId(obj)
    }

    public setDisqusForumShortname(obj) {
        this.getTemplateViewModel().disqusForumShortname(obj)
    }

    public setDisqusCommentCountOnBrowseClip(obj) {
        this.getTemplateViewModel().disqusCommentCountOnBrowseClip(obj)
    }

    public setEchoboxEnable(obj) {
        this.getTemplateViewModel().echoboxEnable(obj)
    }
    public setOpenWebSpotId(obj) {
        this.getTemplateViewModel().openwebSpotId(obj)
    }

    public setSovrnId(obj){
        this.getTemplateViewModel().sovrnId(obj);
    }
    public setSkimlinksId(obj){
        this.getTemplateViewModel().skimlinksId(obj);
    }
    public setHowlId(obj){
        this.getTemplateViewModel().howlId(obj);
    }

    public setSiteGa4MeasurementId(obj) {
        this.getTemplateViewModel().sitega4MeasurementId(obj)
    }


    public setSentinelMeasurementID(obj) {
        this.getTemplateViewModel().sentinelMeasurementID(obj)
    }

    public setMatomoSiteId(obj) {
        this.getTemplateViewModel().matomoSiteId(obj)
    }

    public setMatomoUrl(obj) {
        this.getTemplateViewModel().matomoUrl(obj)
    }

    public setBrazeWebApiKey(obj) {
        this.getTemplateViewModel().brazeWebApiKey(obj)
    }

    public setBrazeSdkEndpoint(obj) {
        this.getTemplateViewModel().brazeSdkEndpoint(obj)
    }

    public setCampaignerAccountId(obj) {
        this.getTemplateViewModel().campaignerAccountId(obj)
    }
    public getSiteSettings() {
        let externalLinkWhitelist = this.getTemplateViewModel().externalLinkWhitelist();
        if (externalLinkWhitelist) {
            externalLinkWhitelist = externalLinkWhitelist.split("\n")
                .filter((item) => item.trim() != "")
                .map((item) => item.trim()).join("\n");
        }
        return {
            siteName: this.getTemplateViewModel().siteName(),
            alternateSiteName: this.getTemplateViewModel().alternateSiteName(),
            title: this.getTemplateViewModel().title(),
            description: this.getTemplateViewModel().description(),
            rssChannelDescription: this.getTemplateViewModel().rssChannelDescription(),
            rssAdContent: this.getTemplateViewModel().rssAdContent(),
            foundingDate: this.getTemplateViewModel().foundingDate(),
            gtmAccount: this.getTemplateViewModel().gtmAccount(),
            fbappAccount: this.getTemplateViewModel().fbappAccount(),
            metaPixelId: this.getTemplateViewModel().metaPixelId(),
            sitega4MeasurementId: this.getTemplateViewModel().sitega4MeasurementId(),
            sentinelMeasurementID: this.getTemplateViewModel().sentinelMeasurementID(),
            matomoSiteId: this.getTemplateViewModel().matomoSiteId(),
            matomoUrl: this.getTemplateViewModel().matomoUrl(),
            brazeWebApiKey: this.getTemplateViewModel().brazeWebApiKey(),
            brazeSdkEndpoint: this.getTemplateViewModel().brazeSdkEndpoint(),
            campaignerAccountId: this.getTemplateViewModel().campaignerAccountId(),
            disqusForumShortname: this.getTemplateViewModel().disqusForumShortname(),
            openwebSpotId: this.getTemplateViewModel().openwebSpotId(),
            sovrnId: this.getTemplateViewModel().sovrnId(),
            skimlinksId: this.getTemplateViewModel().skimlinksId(),
            howlId: this.getTemplateViewModel().howlId(),
            disqusCommentCountOnBrowseClip: this.getTemplateViewModel().disqusCommentCountOnBrowseClip(),
            echoboxEnable: this.getTemplateViewModel().echoboxEnable(),
            contactAddress: this.getTemplateViewModel().contactAddress(),
            externalLinkWhitelist: externalLinkWhitelist
        }
    }


    protected onClickSaveFollowUsLinks(data, param): any {
        this.caller.saveData(data, param);
    }

    protected onClickCancelFollowUsLinks(): any {
        this.caller.cancelFollowUsLinks()
    }

    // protected onClickSaveRelatedBrandLinks(data, param): any {
    //     this.caller.saveData(data, param)
    // }

    protected onClickCancelRelatedBrandLinks(): any {
        this.caller.cancelRelatedBrandLinks()
    }

    protected onClickCancelSiteSettings(): any {
        this.caller.cancelSiteSettings()
    }

    protected onClickSaveSiteSettings(): any {
        this.caller.saveSiteSettings();
    }

    protected setFacebookDataOnForm(obj) {
        this.getTemplateViewModel().facebookLink(obj.link)
        this.getTemplateViewModel().enableFacebookLink(obj.enabled)
    }

    protected setTwitterDataOnForm(obj) {
        this.getTemplateViewModel().twitterLink(obj.link)
        this.getTemplateViewModel().enableTwitterLink(obj.enabled)
    }

    protected setTiktokDataOnForm(obj) {
        this.getTemplateViewModel().tiktokLink(obj.link)
        this.getTemplateViewModel().enableTiktokLink(obj.enabled)
    }

    protected setLinkedInDataOnForm(obj) {
        this.getTemplateViewModel().linkedInLink(obj.link)
        this.getTemplateViewModel().enableLinkedInLink(obj.enabled)
    }

    protected setThreadsDataOnForm(obj) {
        this.getTemplateViewModel().threadsLink(obj.link)
        this.getTemplateViewModel().enableThreadsLink(obj.enabled)
    }

    protected setBlueSkyDataOnForm(obj) {
        this.getTemplateViewModel().blueSkyLink(obj.link)
        this.getTemplateViewModel().enableBlueSkyLink(obj.enabled)
    }

    protected setTwitchDataOnForm(obj) {
        this.getTemplateViewModel().twitchLink(obj.link)
        this.getTemplateViewModel().enableTwitchLink(obj.enabled)
    }

    protected setInstagramDataOnForm(obj) {
        this.getTemplateViewModel().instagramLink(obj.link)
        this.getTemplateViewModel().enableInstagramLink(obj.enabled)
    }

    protected setPinterestDataOnForm(obj) {
        this.getTemplateViewModel().pinterestLink(obj.link)
        this.getTemplateViewModel().enablePinterestLink(obj.enabled)
    }

    protected setSpotifyDataOnForm(obj) {
        this.getTemplateViewModel().spotifyLink(obj.link)
        this.getTemplateViewModel().enableSpotifyLink(obj.enabled)
    }

    protected setAnchorDataOnForm(obj) {
        this.getTemplateViewModel().anchorLink(obj.link)
        this.getTemplateViewModel().enableAnchorLink(obj.enabled)
    }

    protected setMegaphoneDataOnForm(obj) {
        this.getTemplateViewModel().megaphoneLink(obj.link)
        this.getTemplateViewModel().enableMegaphoneLink(obj.enabled)
    }

    protected setDiscordDataOnForm(obj) {
        this.getTemplateViewModel().discordLink(obj.link)
        this.getTemplateViewModel().enableDiscordLink(obj.enabled)
    }

    protected setTelegramDataOnForm(obj) {
        this.getTemplateViewModel().telegramLink(obj.link)
        this.getTemplateViewModel().enableTelegramLink(obj.enabled)
    }

    protected setSnapchatDataOnForm(obj) {
        this.getTemplateViewModel().snapchatLink(obj.link)
        this.getTemplateViewModel().enableSnapchatLink(obj.enabled)
    }

    protected setYoutubeDataOnForm(obj) {
        this.getTemplateViewModel().youtubeLink(obj.link)
        this.getTemplateViewModel().enableYoutubeLink(obj.enabled)
    }

    protected setRssFeedDataOnForm(obj) {
        this.getTemplateViewModel().rssFeedLink(obj.link)
        this.getTemplateViewModel().enableRssFeedkLink(obj.enabled)
    }


    protected setNewsletterDataOnForm(obj) {
        this.getTemplateViewModel().newsLetterLink(obj.link)
        this.getTemplateViewModel().enableNewsletterLink(obj.enabled)
    }

    protected setAmazonDataOnForm(obj) {
        this.getTemplateViewModel().amazonLink(obj.link)
        this.getTemplateViewModel().enableAmazonLink(obj.enabled)
    }

    protected setAcastDataOnForm(obj) {
        this.getTemplateViewModel().acastLink(obj.link)
        this.getTemplateViewModel().enableAcastLink(obj.enabled)
    }

    protected setFeedlyDataOnForm(obj) {
        this.getTemplateViewModel().feedlyLink(obj.link)
        this.getTemplateViewModel().enableFeedlyLink(obj.enabled)
    }

    protected setPushbulletDataOnForm(obj) {
        this.getTemplateViewModel().pushbulletLink(obj.link)
        this.getTemplateViewModel().enablePushbulletLink(obj.enabled)
    }

    protected setGoogleNewsDataOnForm(obj) {
        this.getTemplateViewModel().googleNewsLink(obj.link)
        this.getTemplateViewModel().enableGoogleNewsLink(obj.enabled)
    }

    protected setGoogleDiscoverDataOnForm(obj) {
        this.getTemplateViewModel().googleDiscoverLink(obj.link)
        this.getTemplateViewModel().enableGoogleDiscoverLink(obj.enabled)
    }

    protected setGoogleSearchDataOnForm(obj) {
        this.getTemplateViewModel().googleSearchLink(obj.link)
        this.getTemplateViewModel().enableGoogleSearchLink(obj.enabled)
    }

    protected setRedditDataOnForm(obj) {
        this.getTemplateViewModel().redditLink(obj.link)
        this.getTemplateViewModel().enableRedditLink(obj.enabled)
    }

    protected setFlipboardDataOnForm(obj) {
        this.getTemplateViewModel().flipboardLink(obj.link)
        this.getTemplateViewModel().enableFlipboardLink(obj.enabled)
    }


    public buildFollowLinksViewModel() {
        return [

            //youtube
            {
                type: this.getTemplateViewModel().youtubeType(),
                enabled: this.getTemplateViewModel().enableYoutubeLink(),
                link: this.getTemplateViewModel().youtubeLink()
            },
            //facebook
            {
                type: this.getTemplateViewModel().facebookType(),
                enabled: this.getTemplateViewModel().enableFacebookLink(),
                link: this.getTemplateViewModel().facebookLink()
            },
            //instagram
            {
                type: this.getTemplateViewModel().instagramType(),
                enabled: this.getTemplateViewModel().enableInstagramLink(),
                link: this.getTemplateViewModel().instagramLink()
            },
            //twitter
            {
                type: this.getTemplateViewModel().twitterType(),
                enabled: this.getTemplateViewModel().enableTwitterLink(),
                link: this.getTemplateViewModel().twitterLink()

            },
            //reddit
            {
                type: this.getTemplateViewModel().redditType(),
                enabled: this.getTemplateViewModel().enableRedditLink(),
                link: this.getTemplateViewModel().redditLink()
            },
            //tiktok
            {
                type: this.getTemplateViewModel().tiktokType(),
                enabled: this.getTemplateViewModel().enableTiktokLink(),
                link: this.getTemplateViewModel().tiktokLink()

            },
            //linkedIn
            {
                type: this.getTemplateViewModel().linkedInType(),
                enabled: this.getTemplateViewModel().enableLinkedInLink(),
                link: this.getTemplateViewModel().linkedInLink()

            },
            //threads
            {
                type: this.getTemplateViewModel().threadsType(),
                enabled: this.getTemplateViewModel().enableThreadsLink(),
                link: this.getTemplateViewModel().threadsLink()

            },
            //bluesky
            {
                type: this.getTemplateViewModel().blueSkyType(),
                enabled: this.getTemplateViewModel().enableBlueSkyLink(),
                link: this.getTemplateViewModel().blueSkyLink()

            },
            //twitch
            {
                type: this.getTemplateViewModel().twitchType(),
                enabled: this.getTemplateViewModel().enableTwitchLink(),
                link: this.getTemplateViewModel().twitchLink()

            },
            //pinterest
            {
                type: this.getTemplateViewModel().pinterestType(),
                enabled: this.getTemplateViewModel().enablePinterestLink(),
                link: this.getTemplateViewModel().pinterestLink()
            },
            //Spotify
            {
                type: this.getTemplateViewModel().spotifyType(),
                enabled: this.getTemplateViewModel().enableSpotifyLink(),
                link: this.getTemplateViewModel().spotifyLink()
            },
            //Anchor
            {
                type: this.getTemplateViewModel().anchorType(),
                enabled: this.getTemplateViewModel().enableAnchorLink(),
                link: this.getTemplateViewModel().anchorLink()
            },
            //Megaphone
            {
                type: this.getTemplateViewModel().megaphoneType(),
                enabled: this.getTemplateViewModel().enableMegaphoneLink(),
                link: this.getTemplateViewModel().megaphoneLink()
            },
            //acast
            {
                type: this.getTemplateViewModel().acastType(),
                enabled: this.getTemplateViewModel().enableAcastLink(),
                link: this.getTemplateViewModel().acastLink()
            },
            //Discord
            {
                type: this.getTemplateViewModel().discordType(),
                enabled: this.getTemplateViewModel().enableDiscordLink(),
                link: this.getTemplateViewModel().discordLink()
            },
            //Telegram
            {
                type: this.getTemplateViewModel().telegramType(),
                enabled: this.getTemplateViewModel().enableTelegramLink(),
                link: this.getTemplateViewModel().telegramLink()
            },
            //Snapchat
            {
                type: this.getTemplateViewModel().snapchatType(),
                enabled: this.getTemplateViewModel().enableSnapchatLink(),
                link: this.getTemplateViewModel().snapchatLink()
            },
            //google-news
            {
                type: this.getTemplateViewModel().googleNewsType(),
                enabled: this.getTemplateViewModel().enableGoogleNewsLink(),
                link: this.getTemplateViewModel().googleNewsLink()
            },
            //google-discover
            {
                type: this.getTemplateViewModel().googleDiscoverType(),
                enabled: this.getTemplateViewModel().enableGoogleDiscoverLink(),
                link: this.getTemplateViewModel().googleDiscoverLink()
            },
            //google-search
            {
                type: this.getTemplateViewModel().googleSearchType(),
                enabled: this.getTemplateViewModel().enableGoogleSearchLink(),
                link: this.getTemplateViewModel().googleSearchLink()
            },
            //feedly
            {
                type: this.getTemplateViewModel().feedlyType(),
                enabled: this.getTemplateViewModel().enableFeedlyLink(),
                link: this.getTemplateViewModel().feedlyLink()
            },
            //flipboard
            {
                type: this.getTemplateViewModel().flipboardType(),
                enabled: this.getTemplateViewModel().enableFlipboardLink(),
                link: this.getTemplateViewModel().flipboardLink()
            },
            //pushbullet
            {
                type: this.getTemplateViewModel().pushbulletType(),
                enabled: this.getTemplateViewModel().enablePushbulletLink(),
                link: this.getTemplateViewModel().pushbulletLink()
            },
            //rss feed
            {
                type: this.getTemplateViewModel().rssFeedType(),
                enabled: this.getTemplateViewModel().enableRssFeedkLink(),
                link: this.getTemplateViewModel().rssFeedLink()
            },
            //newsletter
            {
                type: this.getTemplateViewModel().newsLetterType(),
                enabled: this.getTemplateViewModel().enableNewsletterLink(),
                link: this.getTemplateViewModel().newsLetterLink()
            },
            //amazon
            {
                type: this.getTemplateViewModel().amazonType(),
                enabled: this.getTemplateViewModel().enableAmazonLink(),
                link: this.getTemplateViewModel().amazonLink()
            }
        ];
    }

    public set_siteSettings(obj) {
        this.getTemplateViewModel().siteSettings(obj)
    }

    public onClickCancelPencilBanner(): any {
        this.caller.cancelPencilBanner()
    }

    public onClickSavePencilBanner(data, param): any {
        this.caller.saveData(data, param);
    }

    protected updatePencilBannerCount(textValue): any {
        this.getTemplateViewModel().pencilBannerTextLinkCount(textValue.length)
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/config_general_template.ts